import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

const styles = {
  wrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'white',
    display: 'flex',
  },
  content: { margin: 'auto', textAlign: 'center' },
}

const useStyles = makeStyles(styles)

const UIBlocker = props => {
  const classes = useStyles()

  return (
    <div className={classes.wrapper}>
      <div className={classes.content}>{props.children}</div>
    </div>
  )
}

export default UIBlocker
